import { connect } from 'react-redux';
import { DnsManagerComponent } from '../../components';
import { getDomains, getDomainRecords, addRecord, editRecord } from '../../redux/actions/dns';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

const mapStateToProps = state => ({
  domains: state.dns.domains,
  records: state.dns.records,
  loadingDomains: state.dns.loadingDomains,
  loadingRecords: state.dns.loadingRecords
})

const mapDispatchToProps = { getDomains, getDomainRecords, addRecord, editRecord, push }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DnsManagerComponent));



// WEBPACK FOOTER //
// ./src/containers/DnsManager/DnsManager.js